import React from "react";

const Nopage = () => {
  return (
    <div class="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
      <header class="mb-auto">
          <img
            src="../logo/Logo.png"
            height="55"
            width="55"
            alt="SearchMe"
            class="mx-auto mb-0"
          />
      </header>

      <main class="px-3">
        <h1 class="h1-search fw-bold">
          Search<span class="h1-me">Me</span>
        </h1>
        <h2 class="h1-search fw-bold">404</h2>
        <h3 class="lead h1-search fw-bold">Page not found</h3>
        <p class="lead h1-search fw-bold">
          The specified file was not found on this website. Please check the URL
          for mistakes and try again.
        </p>
      </main>

      <footer class="mt-auto h1-search">
        <p>&copy; SearchMe 2025</p>
      </footer>
    </div>
  );
};

export default Nopage;
